import PeopleIcon from '@mui/icons-material/People';
import { ReactElement } from 'react';
import {
  BulkDeleteWithConfirmButton,
  Datagrid,
  List,
  ReferenceField,
  SearchInput,
  TextField,
  usePermissions,
  useTranslate,
} from 'react-admin';

import SubscriptionEditEmbedded from './SubscriptionEditEmbedded';
export const SubscriptionIcon = PeopleIcon;

// function that returns an array of filters in react admin
const getSubscriptionFilters = (): ReactElement[] => {
  const filters = [
    <SearchInput source="display_name,email" alwaysOn />,

    // permissions === 'master' ? <TextInput source="role" /> : null,
  ];
  return filters.filter((filter) => filter !== null) as ReactElement[];
};

const SubscriptionBulkActionButtons = (props: any) => <BulkDeleteWithConfirmButton {...props} />;

const SubscriptionList = () => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  return (
    <List
      filters={getSubscriptionFilters()}
      // filterDefaultValues={{ role: 'Subscription' }}
      sort={{ field: 'created_at', order: 'DESC' }}
    >
      <Datagrid
        expand={<SubscriptionEditEmbedded />}
        bulkActionButtons={<SubscriptionBulkActionButtons />}
        rowClick="expand"
        optimized
      >
        <ReferenceField
          source="client_id"
          reference="client"
          label={translate('resources.subscriptions.fields.client')}
        >
          <TextField source="name" />
        </ReferenceField>

        <ReferenceField source="user_id" reference="user" label={translate('resources.subscriptions.fields.user')}>
          <TextField source="display_name" />
        </ReferenceField>
      </Datagrid>
    </List>
  );
};

export default SubscriptionList;
